import Button from 'components/Forms/Button/Button';
import { HTMLAttributes } from 'react';
import styled, { css } from 'styled-components';

type OrderActionWrapperStyledProps = HTMLAttributes<HTMLDivElement> & {
    desktopAlign?: 'center' | 'right';
};

export const OrderActionWrapperStyled = styled.div<OrderActionWrapperStyledProps>(
    ({ theme, desktopAlign }) => css`
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 90px;
        margin-top: 20px;

        ${desktopAlign === 'right' &&
        css`
            @media ${theme.mediaQueries.queryNotLargeDesktop} {
                margin-top: 20px;
            }
        `}

        @media ${theme.mediaQueries.queryVl} {
            align-items: flex-start;

            ${desktopAlign === 'right' &&
            css`
                align-items: flex-end;
                margin-top: 40px;
            `}

            ${desktopAlign === 'center' &&
            css`
                align-items: center;
            `}
        }
    `,
);

export const ButtonStyled = styled(Button)(
    ({ theme }) => css`
        @media ${theme.mediaQueries.queryMobile} {
            line-height: 24px;

            font-size: 21px;
        }
    `,
);
